module.exports = __webpack_public_path__ + "img/time@2x.d7a269b5.png";